import Vue from 'vue'
import vueMoment from 'vue-moment'

const moment = require('moment')
require('moment/locale/pt-br')

Vue.use(vueMoment, { moment })

Vue.moment().locale('pt-BR')
